var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"col-12",attrs:{"id":"breadcrumbs"}},_vm._l((_vm.breadcrumbs),function(crumb,index){return _c('div',{key:index,staticClass:"singleBreadcrumb"},[_c('router-link',{attrs:{"to":crumb.link}},[_vm._v(_vm._s(crumb.text))]),_c('span',{staticClass:"separator"},[_vm._v("/")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }